module.exports = __webpack_public_path__ + "media/collection_1.40e91124.mp4";